import api from "./client";
export async function getListings(params = {}) {
    const res = await api.get("/admin/listings", { params });
    return res.data;
}
export async function getListing(id) {
    const res = await api.get(`/admin/listings/${id}`);
    return res.data;
}
export async function createListing(data) {
    const res = await api.post("/admin/listings", data);
    return res.data;
}
export async function updateListing(id, data) {
    const res = await api.put(`/admin/listings/${id}`, data);
    return res.data;
}
export async function deleteListing(id) {
    await api.delete(`/admin/listings/${id}`);
}
